<div class="container my-2">
  <div class="container">
    <div class="text-center">
      <img
        src="assets/images/internship-banner.png"
        alt="icons"
        class="img-fluid"
      />
    </div>

<div class="card shadow-sm mt-4 intern-card">
      <div class="card-body">
        <h3 class="fw-bold mt-4 mb-3 text-center">Available Domains</h3>

        <div class="domaintype mt-4">
          <div class="domains-grid">
            <div class="domain-card p-3 text-center">
              <i class="bi bi-code-slash fs-2 text-primary"></i>
              <h6 class="fw-bold mt-2">.NET Development</h6>
              <small>Build modern apps using ASP.NET, MVC & APIs.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-filetype-py fs-2 text-warning"></i>
              <h6 class="fw-bold mt-2">Python Development</h6>
              <small>Automation, backend services & scripting.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-globe fs-2 text-info"></i>
              <h6 class="fw-bold mt-2">PHP Development</h6>
              <small>Dynamic web apps using PHP & MySQL.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-cpu fs-2 text-danger"></i>
              <h6 class="fw-bold mt-2">AI & Machine Learning</h6>
              <small>Data processing, model building & workflows.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-bootstrap-reboot fs-2 text-primary"></i>
              <h6 class="fw-bold mt-2">Angular Development</h6>
              <small>Build dynamic UI, routing & reusable components.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-phone fs-2 text-success"></i>
              <h6 class="fw-bold mt-2">Flutter Development</h6>
              <small>Cross-platform Android, iOS & Web apps.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-database fs-2 text-secondary"></i>
              <h6 class="fw-bold mt-2">SQL & Database</h6>
              <small>Queries, optimization & data modelling.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-cloud-check fs-2 text-primary"></i>
              <h6 class="fw-bold mt-2">Cloud Computing</h6>
              <small>AWS/Azure services, deployments & configs.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-git fs-2 text-danger"></i>
              <h6 class="fw-bold mt-2">DevOps</h6>
              <small>CI/CD, automation & GitHub Actions.</small>
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-bug fs-2 text-dark"></i>
              <h6 class="fw-bold mt-2">Software Testing</h6>
              <small>Manual/automation testing & test cases.</small>
            </div>
          </div>
        </div>

        <h3 class="fw-bold mt-5 mb-3 text-center">What You Will Learn</h3>

        <div class="container">
          <div class="row g-4">
            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-kanban fs-2 text-primary"></i>
                <h6 class="fw-bold mt-2">Live Project Experience</h6>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-git fs-2 text-danger"></i>
                <h6 class="fw-bold mt-2">Git/GitHub Workflow</h6>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-list-check fs-2 text-success"></i>
                <h6 class="fw-bold mt-2">Industry Coding Standards</h6>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-file-earmark-text fs-2 text-info"></i>
                <h6 class="fw-bold mt-2">Documentation & Reporting</h6>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-bug-fill fs-2 text-warning"></i>
                <h6 class="fw-bold mt-2">Debugging & Problem Solving</h6>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4">
              <div class="card h-100 text-center p-3 shadow-sm">
                <i class="bi bi-tools fs-2 text-secondary"></i>
                <h6 class="fw-bold mt-2">Real-Time Tools & Frameworks</h6>
              </div>
            </div>
          </div>
        </div>

        <h3 class="fw-bold mt-5 mb-3 text-center">Internship Includes</h3>

        <div class="container">
          <div class="row g-3 justify-content-center">
            <!-- Card 1 -->
            <div class="col-md-3 col-sm-6">
              <div class="feature-card p-3 text-center">
                <i class="bi bi-patch-check fs-2 text-primary"></i>
                <h6 class="mt-2 fw-bold">Certificate of Completion</h6>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col-md-3 col-sm-6">
              <div class="feature-card p-3 text-center">
                <i class="bi bi-file-earmark-person fs-2 text-primary"></i>
                <h6 class="mt-2 fw-bold">Resume Building Guidance</h6>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-md-3 col-sm-6">
              <div class="feature-card p-3 text-center">
                <i class="bi bi-person-video3 fs-2 text-primary"></i>
                <h6 class="mt-2 fw-bold">1:1 Mentor Support</h6>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-md-3 col-sm-6">
              <div class="feature-card p-3 text-center">
                <i class="bi bi-briefcase-fill fs-2 text-primary"></i>
                <h6 class="mt-2 fw-bold">Job-Oriented Training</h6>
              </div>
            </div>
          </div>
        </div>

        <h5 class="fw-bold mt-4 mb-2">Eligibility</h5>
        <ul>
          <li>B.Tech / M.Tech (CSE / IT preferred)</li>
          <li>70% or above</li>
          <li>Strong interest in coding</li>
        </ul>

        <h5 class="fw-bold mt-4 mb-2">Duration</h5>
        <ul>
          <li>4 – 8 Weeks (Based on domain)</li>
        </ul>

        <div class="text-center mt-4">
          <a
  class="btn btn-primary px-4 py-2"
  routerLink="/internship/apply/"
  href="/internship/apply/?type=programming"
  [queryParams]="{ type: 'programming' }"
>
  Apply Now
</a>

          <a
            routerLink="/careers"
            href="/careers"
            class="btn btn-outline-secondary px-4 py-2 ms-2"
            style="border-radius: 6px"
          >
            Back
          </a>
        </div>
      </div>
    </div>